import * as THREE from 'three';

export default class Renderer {
  constructor(experience) {
    this.experience = experience;
    this.canvas = this.experience.canvas;
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
    this.camera = this.experience.camera;

    this.darkColor = new THREE.Color('#000000'); // Vercel pitch black
    this.pastelColor = new THREE.Color('#f5f4ef');
    this.currentColor = this.pastelColor.clone(); // Default to clean light mode

    this.setInstance();
  }

  setInstance() {
    this.instance = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
      powerPreference: 'high-performance',
      alpha: false
    });

    this.instance.toneMapping = THREE.ACESFilmicToneMapping;
    this.instance.toneMappingExposure = 0.95;
    this.instance.shadowMap.enabled = true;
    this.instance.shadowMap.type = THREE.PCFSoftShadowMap;

    this.instance.setSize(this.sizes.width, this.sizes.height);
    this.instance.setPixelRatio(this.sizes.pixelRatio);
    this.instance.setClearColor(this.currentColor, 1);
  }

  setTheme(isDark) {
    const target = isDark ? this.darkColor : this.pastelColor;
    this.currentColor.copy(target);
    this.instance.setClearColor(this.currentColor, 1);
    this.instance.toneMappingExposure = isDark ? 1.25 : 0.95;
  }

  resize() {
    this.instance.setSize(this.sizes.width, this.sizes.height);
    this.instance.setPixelRatio(this.sizes.pixelRatio);
  }

  update() {
    if (!this.experience.effects || !this.experience.effects.enabled) {
      this.instance.render(this.scene, this.camera.instance);
    }
  }
}
